export default __webpack_public_path__ + "static/GrangemouthBroncos-ca6be15649b13a650cc51a84ae50a637.jpg";